export type ImageFromCDNType =
  | "image-product"
  | "image-category"
  | "image-swatch"
  | "image-cms";
const absoluteUrl = /^(data|http|https)?:/i;
export const isAbsoluteUrl = (url) => {
  return absoluteUrl.test(url);
};
interface IResolveOptions {
  [key: string]: string | number;
  type: ImageFromCDNType;
  aspectRatio?: number;
}
export const mediaBases = new Map()
  .set("image-product", "catalog/product/")
  .set("image-category", "catalog/category/")
  .set("image-swatch", "attribute/swatch/");
export const cmsBases = new Map().set("image-cms", "");

const joinUrls = (base: string, url: string) =>
  (base.endsWith("/") ? base.slice(0, -1) : base) +
  "/" +
  (url.startsWith("/") ? url.slice(1) : url);

const magentoBackendURL = "https://shop.curnonwatch.com";
const mediaBackend = magentoBackendURL + "/media/";
const cmsBackend = "https://cms.curnonwatch.com";

export const resolveImageUrlOnly = (options: {
  type: ImageFromCDNType;
  src: string;
}) => {
  const { type = "image-product", src } = options;

  if (!src) return undefined;
  let baseURL = new URL(src, mediaBackend);

  //abs image always no processing
  if (isAbsoluteUrl(src)) {
    return src;
  }
  // this is magento based
  if (mediaBases.has(type)) {
    const mediaBase = mediaBases.get(type);
    if (!baseURL.pathname.includes(mediaBase)) {
      baseURL = new URL(joinUrls(mediaBase, src), mediaBackend);
    }
    const finalUrl = baseURL;
    return finalUrl.toString();
  }
  //this is cms based
  if (cmsBases.has(type)) {
    const finalUrl = new URL(src, cmsBackend);
    return finalUrl.toString();
  }
  //default
  return src;
};
